"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaymentTransport = void 0;
const typebox_1 = require("@sinclair/typebox");
const common_1 = require("../../common");
const payment_processor_1 = require("./payment-processor");
const payment_status_1 = require("./payment-status");
/**
 * Unified billing (v2) payment. One generic `paymentProcessorReferenceID` replaces the per-system id
 * columns (Rainforest payin, Stripe charge, Plaid transfer, SVB clearing event); `paymentProcessor`
 * says which system's id it is.
 */
exports.PaymentTransport = typebox_1.Type.Object({
    id: typebox_1.Type.String({ format: 'uuid' }),
    invoiceID: typebox_1.Type.String({ format: 'uuid' }),
    haulerID: typebox_1.Type.String({ format: 'uuid' }),
    date: typebox_1.Type.String({ format: 'date-time' }),
    amount: typebox_1.Type.Integer(),
    paymentMethod: common_1.PaymentMethod,
    /**
     * What moved the money. `MANUAL` for payments recorded off-platform (check, cash, wire).
     */
    paymentProcessor: payment_processor_1.PaymentProcessor,
    /**
     * That system's own id for this payment. Opaque, not a foreign key; always absent when
     * `paymentProcessor` is `MANUAL`.
     */
    paymentProcessorReferenceID: typebox_1.Type.Optional(typebox_1.Type.String()),
    /**
     * Lifecycle status of the money movement itself. `MANUAL` payments are recorded only once the
     * money is already known to have moved, so they default to `COMPLETED`; a processor payment may
     * sit at `PENDING`, `AUTHORIZING`, or `PROCESSING` until it clears.
     */
    status: payment_status_1.PaymentStatus,
    /**
     * Identifies the payment to a human. Read it through `paymentMethod`: last four of the card for
     * `CREDIT_CARD`, last four of the account for `ACH`, check number for `CHECK`, confirmation number
     * for `WIRE`. Never restates `paymentMethod` itself.
     */
    paymentIdentifier: typebox_1.Type.Optional(typebox_1.Type.String()),
    enteredByUserID: typebox_1.Type.String(),
    paymentSentDate: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'date-time' })),
    paymentReceivedDate: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'date-time' })),
    notes: typebox_1.Type.Optional(typebox_1.Type.String()),
    metadata: typebox_1.Type.Optional(common_1.MetaData),
});
//# sourceMappingURL=payment-transport.js.map